import React, { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LandingPage from "./LandingPage";
import useLandingInteractions from "./useLandingInteractions";
import "./landing.css";

const META_PIXEL_ID = "1274560808030548";

const loadMetaPixel = () => {
  if (window.fbq) return;

  let pixelLoaded = false;

  const injectPixel = () => {
    if (pixelLoaded || window.fbq) return;
    pixelLoaded = true;

    window.removeEventListener("scroll", injectPixel);
    window.removeEventListener("mousemove", injectPixel);
    window.removeEventListener("touchstart", injectPixel);
    window.removeEventListener("keydown", injectPixel);

    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */

    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  };

  window.addEventListener("scroll", injectPixel, { passive: true });
  window.addEventListener("mousemove", injectPixel, { passive: true });
  window.addEventListener("touchstart", injectPixel, { passive: true });
  window.addEventListener("keydown", injectPixel, { passive: true });
  window.setTimeout(injectPixel, 5000);
};

const Presentation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [oauthFeedback, setOauthFeedback] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  useLandingInteractions();

  useEffect(() => {
    loadMetaPixel();
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const isConnected = query.get("ml_connected");
    const mlError = query.get("ml_error");

    if (isConnected === "true") {
      setOauthFeedback({
        open: true,
        severity: "success",
        message: "Cuenta de MercadoLibre conectada exitosamente.",
      });
      navigate(location.pathname, { replace: true });
      return;
    }

    if (mlError) {
      setOauthFeedback({
        open: true,
        severity: "error",
        message: `No se pudo conectar MercadoLibre: ${decodeURIComponent(mlError)}`,
      });
      navigate(location.pathname, { replace: true });
    }
  }, [location.pathname, location.search, navigate]);

  return (
    <>
      <LandingPage />

      <Snackbar
        open={oauthFeedback.open}
        autoHideDuration={6000}
        onClose={() => setOauthFeedback((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ zIndex: 10001 }}
      >
        <Alert
          severity={oauthFeedback.severity}
          variant="filled"
          onClose={() => setOauthFeedback((prev) => ({ ...prev, open: false }))}
          sx={{ width: "100%" }}
        >
          {oauthFeedback.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Presentation;
